import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { Scale, Info } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const LegalSection = () => {
  const { t } = useLang();
  const clauses = t("disclaimer.clauses");

  return (
    <section id="legal" data-testid="legal-section" className="py-20 lg:py-28 bg-[#F8FAFC] bg-blueprint relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t("legal.eyebrow")}
          title={
            <>
              {t("legal.titleA")}
              <span className="text-blue-700">{t("legal.titleB")}</span>
            </>
          }
          sub={t("legal.sub")}
        />

        <div className="border-t border-slate-200">
          {clauses.map((c, i) => (
            <motion.div
              key={i}
              data-testid={`legal-clause-${i + 1}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-12 gap-4 sm:gap-8 py-8 lg:py-10 border-b border-slate-200 hover:bg-white/70 transition-colors duration-300 px-2 sm:px-4"
            >
              <div className="col-span-2 sm:col-span-1">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-white border-2 border-blue-600 font-mono font-extrabold text-blue-700 text-sm shadow-[0_0_0_6px_rgba(29,78,216,0.08)]">
                  {i + 1}
                </span>
              </div>
              <div className="col-span-10 sm:col-span-11">
                <h3 className="text-lg sm:text-xl font-bold text-slate-900 tracking-tight">{c.title}</h3>
                <p className="mt-2.5 text-sm sm:text-base text-slate-500 leading-relaxed max-w-3xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-10 flex items-start gap-3.5 p-5 rounded-2xl border border-amber-200 bg-amber-50/70">
            <Info className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
            <p className="text-sm text-slate-600 leading-relaxed">{t("legal.note")}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
